import type { AxiosError } from 'axios';

import { axiosClient } from '../../client';

import type { RecoveryPasswordRequestType } from 'core/domains/auth';

export async function recoverPassword(
  data: RecoveryPasswordRequestType,
): Promise<{ status: number }> {
  const onError = (error: AxiosError) => {
    return Promise.reject(error);
  };

  axiosClient.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => onError(error?.response || error),
  );

  return axiosClient.post('auth/recover', data);
}
